import recurringProphyBotox from './recurring/recurringProphyBotox'
import recurringProphyTopiramate from './recurring/recurringProphyTopiramate'
import recurringProphyErenumab from './recurring/recurringProphyErenumab'
import recurringProphyFremanezumab from './recurring/recurringProphyFremanezumab'
import recurringProphyAmitriptyline from './recurring/recurringProphyAmitriptyline'
import recurringProphyMagnesium from './recurring/recurringProphyMagnesium'
import squareStudy from './recurring/squareStudy'
// import testStudy from './recurring/test'

// sample study object:
// let object = {
//   studyName: 'test-study', // this is the name of the study in backend
//   canJoin: true, // whether this study is available for joining
//   canSeeResults: true // whether this study has a results page
//   category: 'Lifestyle" // for emptyprophyStateGroupCard sorting
//   molecule: optional, the old medication studies need this
//   header: 'Test Study', // this is the header in Migraine Buddy
//   subheader: 'This is a test study.', // this is the smalltext below the header
//   baselineFormId: 'baseline-leyou-test', // baselineformid in backend
//   baselineQuestionnaire: {}, // questionnaire object
//   recurringFormId: 'recurring-leyou-test', // recurringformid in backend
//   recurringQuestionnaire: {} // questionnaire object
// }

// key should be the study name in backend

export default {
  'botox-internal': recurringProphyBotox,
  'topiramate-internal': recurringProphyTopiramate,
  'erenumab-internal': recurringProphyErenumab,
  'fremanezumab-internal': recurringProphyFremanezumab,
  'amitriptyline-internal': recurringProphyAmitriptyline,
  'magnesium-internal': recurringProphyMagnesium,
  'square-study': squareStudy
  // 'leyou-test-study': testStudy
}



// WEBPACK FOOTER //
// ./src/store/recurringStudiesList.js